import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/modules/shared.module';
import { MomentModule } from 'ngx-moment'
import { DirectLinkService } from './directlink.service';
import { DirectLinkComponent } from './directlink.component';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
    imports: [
      SharedModule,
      RouterModule,
      NgxMaskModule,
      MomentModule
    ],
    providers: [DirectLinkService],
    declarations: [
      DirectLinkComponent
    ]
  })
  export class DirectLinkModule { }